import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddEditRoleGroupPageRoutingModule } from './add-edit-role-group-routing.module';

import { AddEditRoleGroupPage } from './add-edit-role-group.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddEditRoleGroupPageRoutingModule,
    BhInputComponentModule,
    PipesModule
  ],
  declarations: [AddEditRoleGroupPage]
})
export class AddEditRoleGroupPageModule {}
